export enum EntityTagName {
  Grandfathering = 'Grandfathering',
  PriorIncrease = 'PriorIncrease',
  Volt = 'Volt',
  Wildcard = 'Wild Card'
}
